import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './components/pages/HomePage/HomePage';
import CalcularHorarios from './components/pages/CalcularHorarios/CalcularHorarios';
import AcomodamientoSalones from './components/pages/AcomodamientoSalones/AcomodamientoSalones';
import DashboardAdmin from './components/pages/DashboardAdmin/DashboardAdmin';
import ImportarDatos from './components/pages/ImportarDatos/ImportarDatos';
import { MOSTRAR_CALCULAR_HORARIOS, MOSTRAR_ACOMODAMIENTO_SALONES } from './utils/featureFlags';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {MOSTRAR_CALCULAR_HORARIOS && <Route path="/calcular-horarios" element={<CalcularHorarios />} />}
      {MOSTRAR_ACOMODAMIENTO_SALONES && (
        <Route path="/acomodamiento-salones" element={<AcomodamientoSalones />} />
      )}
      <Route path="/dashboard-admin" element={<DashboardAdmin />} />
      <Route path="/importar-datos" element={<ImportarDatos />} />
    </Routes>
  );
};

export default App;
